import { render, staticRenderFns } from "./CertificationDialog.vue?vue&type=template&id=2588f6f3&scoped=true&"
import script from "./CertificationDialog.vue?vue&type=script&lang=js&"
export * from "./CertificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./CertificationDialog.vue?vue&type=style&index=0&id=2588f6f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588f6f3",
  null
  
)

export default component.exports